module.exports = __webpack_public_path__ + "static/media/8.19e7f40f.jpeg";